import React, { createContext, useContext, useState } from "react";
import { api, getAuth, setAuth as persistAuth } from "../lib/api";
import { resetPolicyGate } from "../components/policies/PolicySignGate";   // Phase 218
import { clearPolicyAccess } from "../lib/policies";   // Phase 218

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [auth, setAuthState] = useState(getAuth());

  const login = (data) => {
    resetPolicyGate();   // Phase 218: a fresh login always re-checks pending company policies
    clearPolicyAccess();
    persistAuth(data);
    setAuthState(data);
  };

  const logout = () => {
    // Phase 87: tell the server we signed out (best-effort, fire-and-forget) so Agent Tracking
    // can show the agent as "Not logged in"; the token itself stays stateless.
    const current = getAuth();
    const code = current?.municipality?.code;
    if (current?.token && code && current?.user?.role !== "super_admin") {
      api.post(`/t/${code}/auth/logout`, null, { headers: { Authorization: `Bearer ${current.token}` } }).catch(() => {});
    }
    persistAuth(null);
    setAuthState(null);
    resetPolicyGate();   // Phase 218
    clearPolicyAccess();
  };

  // Phase 86: patch the signed-in user (e.g. after changing their own profile photo)
  const updateUser = (patch) => {
    setAuthState((prev) => {
      if (!prev?.user) return prev;
      const next = { ...prev, user: { ...prev.user, ...patch } };
      persistAuth(next);
      return next;
    });
  };

  // Phase 174: refresh the list of role accounts this person holds (from /auth/me or after Super Admin changes)
  const setRoles = (roles) => {
    setAuthState((prev) => {
      if (!prev?.user) return prev;
      const next = { ...prev, roles: Array.isArray(roles) ? roles : [] };
      persistAuth(next);
      return next;
    });
  };

  return <AuthContext.Provider value={{ auth, login, logout, updateUser, setRoles }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);

export function homePathFor(auth) {
  if (!auth?.user) return "/";
  const code = auth.municipality?.code;
  switch (auth.user.role) {
    case "super_admin":
      return "/super";
    case "municipal_admin":
      return `/${code}/admin`;
    case "supervisor":
      return `/${code}/supervisor`;
    case "tax_collector":
      return `/${code}/collector`;
    case "parking_marshal":   // Phase 199: Smart Parking marshal handheld app
      return `/${code}/marshal`;
    case "citizen":
      return `/${code}/portal`;
    default:
      return "/";
  }
}
